module.exports = __webpack_public_path__ + "img/IL.8d3e3085.svg";